import { render, staticRenderFns } from "./GptMessage.vue?vue&type=template&id=523d3fff"
import script from "./GptMessage.vue?vue&type=script&lang=ts"
export * from "./GptMessage.vue?vue&type=script&lang=ts"
import style0 from "./GptMessage.vue?vue&type=style&index=0&id=523d3fff&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports